/**
 * Schema IndexedDB de la caisse de secours (plan, section 1.2).
 *
 * Base `caisse-secours`. Chaque version a sa migration, jouee une seule fois,
 * dans l'ordre, par openDatabase (store/idb.js) : une base en version N qui
 * s'ouvre en version N+2 rejoue N+1 puis N+2, jamais les precedentes.
 * Une migration ne doit JAMAIS etre modifiee une fois livree : on en ajoute
 * une nouvelle (comme les migrations SQL du backend).
 *
 * Version 1 cree tous les magasins du plan, meme si seuls `meta` et
 * l'enrolement servent dans la PR 1.3 : les PR suivantes (catalogue, NIP,
 * ventes, journal, file d'envoi) n'auront pas a changer la version pour
 * exister.
 */

export const DB_NAME = 'caisse-secours';
export const DB_VERSION = 1;

export const STORES = Object.freeze({
    META: 'meta',
    CATALOG_ITEMS: 'catalog_items',
    CATALOG_META: 'catalog_meta',
    EMPLOYEES: 'employees',
    SHIFTS: 'shifts',
    SALES: 'sales',
    JOURNAL: 'journal',
    OUTBOX: 'outbox',
});

/** Cles connues du magasin `meta`. */
export const META_KEYS = Object.freeze({
    TERMINAL: 'terminal',
    DEVICE_TOKEN: 'device_token',
    SIGNING_KEY: 'signing_key',
    TERMINAL_STATUS: 'terminal_status',
    // PR 1.4 : nouvelles cles dans `meta`, sans changer la version de la base
    // (un magasin IndexedDB accepte toute nouvelle cle).
    PIN_SALT: 'pin_salt',
    PIN_LOCKOUT: 'pin_lockout',
    CAISSE_CONFIG: 'caisse_config',
    CATALOG_SIGNING_KEY: 'catalog_signing_key',
    CATALOG_SYNC: 'catalog_sync',
    ROSTER_SYNC: 'roster_sync',
    MANAGER_CONFIRMATION: 'catalog_manager_confirmation',
    // PR 1.5b : quart ouvert (shift_id du magasin `shifts`) et compteur des
    // numeros de vente locaux, ecrits dans la meme transaction que le quart
    // ou la vente.
    OPEN_SHIFT: 'open_shift',
    SALE_COUNTER: 'sale_counter',
});

/** Cle unique du magasin `catalog_meta` : l'instantane en place. */
export const CATALOG_META_KEY = 'current';

/**
 * Migrations par version cible. Chacune recoit la base en cours de mise a
 * niveau et la transaction `versionchange`.
 */
export const MIGRATIONS = Object.freeze({
    1: (db) => {
        db.createObjectStore(STORES.META, { keyPath: 'key' });

        const items = db.createObjectStore(STORES.CATALOG_ITEMS, { keyPath: 'productcode' });
        // UPC, SKU et productcode : un article se retrouve par n'importe lequel.
        items.createIndex('codes', 'codes', { unique: false, multiEntry: true });
        items.createIndex('weight_sku', 'weight_sku', { unique: false });

        db.createObjectStore(STORES.CATALOG_META, { keyPath: 'key' });
        db.createObjectStore(STORES.EMPLOYEES, { keyPath: 'employee_id' });
        db.createObjectStore(STORES.SHIFTS, { keyPath: 'shift_id' });

        const sales = db.createObjectStore(STORES.SALES, { keyPath: 'sale_uuid' });
        sales.createIndex('shift_id', 'shift_id', { unique: false });

        db.createObjectStore(STORES.JOURNAL, { keyPath: 'seq' });
        db.createObjectStore(STORES.OUTBOX, { keyPath: 'seq' });
    },
});
